import React from "react";
import { Grid } from "@mui/material";
import { CheckoutProductList } from "./CheckoutProductList";
import { CheckoutOrder } from "./CheckoutOrder";

export const CheckoutBody = () => {
  return (
    <React.Fragment>
      <Grid container spacing={2} item={true} className=" place-content-center">
        <Grid xs={12} sm={8} md={8} item={true}>
          <CheckoutProductList />
        </Grid>
        <Grid xs={12} sm={4} md={4} item={true}>
          <CheckoutOrder />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
